module.exports = __webpack_public_path__ + "img/bird-6-right.062721f9.png";